<div class="klab-input-otp" [ngClass]="'klab-input-otp--' + size">
  <div class="klab-input-otp__boxes">
    <input
      #otpInput
      class="klab-input-otp__box"
      type="text"
      inputmode="numeric"
      maxlength="1"
      placeholder="x"
      autocomplete="one-time-code"
      [disabled]="disabled"
      (input)="onInput($event, 0)"
      (keydown)="onKeyDown($event, 0)"
      (paste)="onPaste($event, 0)"
      (focus)="onFocus(0)"
    />

    <input
      #otpInput
      class="klab-input-otp__box"
      type="text"
      inputmode="numeric"
      maxlength="1"
      placeholder="x"
      autocomplete="one-time-code"
      [disabled]="disabled"
      (input)="onInput($event, 1)"
      (keydown)="onKeyDown($event, 1)"
      (paste)="onPaste($event, 1)"
      (focus)="onFocus(1)"
    />

    <input
      #otpInput
      class="klab-input-otp__box"
      type="text"
      inputmode="numeric"
      maxlength="1"
      placeholder="x"
      autocomplete="one-time-code"
      [disabled]="disabled"
      (input)="onInput($event, 2)"
      (keydown)="onKeyDown($event, 2)"
      (paste)="onPaste($event, 2)"
      (focus)="onFocus(2)"
    />

    <input
      #otpInput
      class="klab-input-otp__box"
      type="text"
      inputmode="numeric"
      maxlength="1"
      placeholder="x"
      autocomplete="one-time-code"
      [disabled]="disabled"
      (input)="onInput($event, 3)"
      (keydown)="onKeyDown($event, 3)"
      (paste)="onPaste($event, 3)"
      (focus)="onFocus(3)"
    />

    <input
      #otpInput
      class="klab-input-otp__box"
      type="text"
      inputmode="numeric"
      maxlength="1"
      placeholder="x"
      autocomplete="one-time-code"
      [disabled]="disabled"
      (input)="onInput($event, 4)"
      (keydown)="onKeyDown($event, 4)"
      (paste)="onPaste($event, 4)"
      (focus)="onFocus(4)"
    />

    <input
      #otpInput
      class="klab-input-otp__box"
      type="text"
      inputmode="numeric"
      maxlength="1"
      placeholder="x"
      autocomplete="one-time-code"
      [disabled]="disabled"
      (input)="onInput($event, 5)"
      (keydown)="onKeyDown($event, 5)"
      (paste)="onPaste($event, 5)"
      (focus)="onFocus(5)"
    />
  </div>
</div>
